import React, { useState } from "react";
import axios from "axios";
import { Link } from "react-router-dom";
import { ArrowLeft, Loader2 } from "lucide-react";
import { useCatalog } from "../context/CatalogContext";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function ForgotPasswordPage() {
  const { hero } = useCatalog();
  const [email, setEmail] = useState("");
  const [busy, setBusy] = useState(false);
  const [sent, setSent] = useState(false);
  const [error, setError] = useState("");

  const gradFrom = hero?.loginGradientFrom || "#2B1810";
  const gradTo = hero?.loginGradientTo || "#8B5A2B";

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setBusy(true);
    try {
      await axios.post(`${API}/auth/forgot-password`, {
        email: email.trim(),
      });
      setSent(true);
    } catch (err) {
      const detail =
        (err && err.response && err.response.data && err.response.data.detail) ||
        err.message ||
        "Could not send reset link. Please try again.";
      setError(String(detail));
    } finally {
      setBusy(false);
    }
  };

  return (
    <div
      className="auth-page"
      style={{
        "--auth-grad-from": gradFrom,
        "--auth-grad-to": gradTo,
      }}
    >
      <div className="auth-form-wrap auth-single">
        <div className="auth-form" data-testid="forgot-password-form">
          <Link
            to="/auth"
            className="auth-back"
            data-testid="forgot-back-to-login"
          >
            <ArrowLeft size={16} /> Back to sign in
          </Link>
          <h2>Reset your password</h2>
          <p className="auth-hint">
            Enter your email address and we'll send you a reset link. If you don't
            receive it in a few minutes, please contact the store on WhatsApp so
            we can help you directly.
          </p>

          {sent ? (
            <div
              className="auth-ok"
              data-testid="forgot-success"
              style={{
                marginTop: 12,
                padding: "14px 16px",
                borderRadius: 10,
                background: "rgba(139, 90, 43, 0.08)",
                color: "#4A3222",
                fontSize: 14,
                lineHeight: 1.5,
              }}
            >
              If that email is registered with us, a reset link has been sent.
              The link is valid for 60 minutes. Please check your inbox — and
              your spam folder just in case.
            </div>
          ) : (
            <form onSubmit={submit}>
              <label className="auth-field">
                <span>Email</span>
                <input
                  type="email"
                  required
                  autoComplete="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  placeholder="you@example.com"
                  data-testid="forgot-email-input"
                />
              </label>
              {error && <div className="auth-error">{error}</div>}
              <button
                type="submit"
                className="btn btn-primary auth-submit"
                disabled={busy}
                data-testid="forgot-submit-button"
              >
                {busy ? (
                  <>
                    <Loader2 size={16} className="spin" /> Sending…
                  </>
                ) : (
                  <>Send reset link</>
                )}
              </button>
            </form>
          )}
        </div>
      </div>
    </div>
  );
}
